import { Injectable, inject } from "@angular/core";
import { DataService } from "./data.service";
import { BehaviorSubject, Observable } from "rxjs";
import { IAdvisoryCommittee, ICounty, ICourses, IDistrict, IFaqs, IGrades, IRoles } from "@core/interfaces/ilookup";
import { ISchool } from "@views/features/management/interfaces/isearchSchool";
import { ISchoolYear } from "@core/interfaces/ischool-year";
import { IUserFilteredLookup } from "@core/interfaces/iuser";

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  dataService = inject(DataService);

  districtSubject$ = new BehaviorSubject<IDistrict | null>(null);
  schoolYearSubject$ = new BehaviorSubject<number | null>(null);

  getOrganizations(): Observable<IDistrict[]> {
    return this.dataService.get(`lookup/organizations`);
  }

  getOrganizationsByUserId(userId: number): Observable<IDistrict[]> {
    return this.dataService.get(`lookup/organizations?userId=${userId}`);
  }

  getRoles(): Observable<IRoles[]> {
    return this.dataService.get(`lookup/roles`);
  }

  getGrades(): Observable<IGrades[]> {
    return this.dataService.get(`lookup/grades`);
  }

  getCourses(): Observable<ICourses[]> {
    return this.dataService.get(`lookup/Courses`);
  }

  getFaqs(): Observable<IFaqs[]> {
    return this.dataService.get(`lookup/faqs`);
  }

  getAdvisoryCommittee(): Observable<IAdvisoryCommittee[]> {
    return this.dataService.get(`lookup/advisory-committee`);
  }

  getCounties(): Observable<ICounty[]> {
    return this.dataService.get(`lookup/counties`);
  }

  getSchools(): Observable<ISchool[]> {
    return this.dataService.get(`lookup/schools`);
  }

  getSchoolsByDistrict(districtId: number): Observable<ISchool[]> {
    return this.dataService.get(`lookup/schools/district/${districtId}`);
  }

  getSchoolYears(): Observable<ISchoolYear[]> {
    return this.dataService.get(`lookup/school-years`);
  }

  getCurrentSchoolYear(): Observable<ISchoolYear> {
    return this.dataService.get(`lookup/current-school-year`);
  }

  getUserFilteredLookup(): Observable<IUserFilteredLookup> {
    return this.dataService.get(`lookup/user-filtered-lookup`);
  }
}
